import React from "react";

function personExcelCell(options, column, gridCell) {
  let row = gridCell.data;
  let prefix = column.dataField;
  let firstName = prefix + "_firstName";
  let lastName = prefix + "_lastName";
  let middleName = prefix + "_middleName";
  if (row[prefix]) {
    options.value = (row[lastName] || "") + "  " + (row[firstName] || "") + "  " + (row[middleName] || "");
  }
}

function personCell(config, columnSpec){
  let prefix = columnSpec.dataField;
  let firstName = prefix + "_firstName";
  let lastName = prefix + "_lastName";
  let middleName = prefix + "_middleName";
  config.dataType = "string";
  config.alignment = "left";
  config.calculateCellValue = (row) => {
    if (row[prefix]) {
      return (row[lastName] || "") + " " + (row[firstName] || "") + " " + (row[middleName] || "");
    } else {
      return null;
    }
  }
}

export {personCell, personExcelCell}
